/*
*根据角色id获取关联员工
*/
const __request = require(`./__request/__request_contentType_json`)
const request = (data) => {
    let pParameter = {
        method: 'post',
        urlSuffix: '/consumer/role/getStaff',
        data: data
    }
    return __request(pParameter)
}
export default request